export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 08 Restroom Retreat.e1a5cb89.mp3";